import { Tableau } from '~src/commonInfra/utils/TableauLog';
import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import TagHttpClient from '~src/httpClient/TAG/TagHttpClient';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';
import { ErrorReason } from '~src/sessionManagement/SessionManagementService';

import { DeleteSiteSMTPCredentialRequest } from './requests/DeleteSiteSMTPCredentialTagRequest';
import { ISiteSMTPSettings, SetSiteSMTPCredentialRequest } from './requests/SetSiteSMTPCredentialTagRequest';

export namespace ExternalSMTPConfiguration {
  export async function setSiteSMTPCredential(emailCustomizationSettings: ISiteSMTPSettings, siteLuid: string) {
    return sendSiteSMTPCredentialTagRequest(new SetSiteSMTPCredentialRequest({...emailCustomizationSettings, site_luid: siteLuid}));
  }

  export async function deleteSiteSMTPCredential(siteLuid: string) {
    return sendSiteSMTPCredentialTagRequest(new DeleteSiteSMTPCredentialRequest({site_luid: siteLuid}));
  }


  async function sendSiteSMTPCredentialTagRequest<TParams, TResult extends ITagResult>(request: TagRequest<TParams, TResult>): Promise<TResult> {
    try {
      const response = await TagHttpClient.sendTagRequest(request);

      if (logErrorFromResponseData(response)) {
        return Promise.reject();
      }

      return response;
    } catch (e) {
      logErrorFromRejectedPromiseReason(e);

      throw e;
    }
  }

  function logErrorFromResponseData(result: ITagResult): boolean{
    const willLogError = !!result.errors && result.errors.length > 0 && !!result.errors[0].message;

    if (willLogError){
      let errorMessage = 'Unknown error from server: ';
      errorMessage = errorMessage.concat('\n ' + result.errors[0].message);
      Tableau.Logger().error(errorMessage);
    }

    return willLogError;
  }

  function logErrorFromRejectedPromiseReason(reason: any){
    if(Object.values(ErrorReason).includes(reason)) {
      let errorMessage = 'Unknown error from server: ';
      errorMessage = errorMessage.concat('\n ' + ErrorReason[reason] + '(' + reason + ')');
      Tableau.Logger().error(errorMessage);
    }
  }
}